import React from 'react'
import popup from '~/views/Popup/popup'
import ResetForm from './resetForm'
import getQueryVariable from '~/tools/getQueryVariable'
import './styles.css'

class ResetPassword extends React.Component {
  state = {
    overlay: this.props.layout.settings.overlay || false
  }

  componentDidMount() {
    const reset = getQueryVariable('pw')
    const passwordNotUpdated = reset !== 'passwordUpdated'

    if (this.state.overlay) {
      popup.fitnessSignInCreate({ 
        showCloseButton: false, 
        ...(passwordNotUpdated && { currentScreen: 'RESET_PASSWORD' })
      })
    } 
  }

	render() {
    if (this.state.overlay) return null
    return <ResetForm />
	}
}


export default ResetPassword;
